<div class="xux-actions-buttons-wrapper" [attr.data-e2e-id]="'xux-btn-' + button.value">
  <button
    *ngIf="!button.childItems && !button.hidden; else dropDownBlock"
    [title]="button.tooltip ? button.tooltip : ''"
    [attr.data-e2e-id]="'modal-btn-' + button.value"
    [style.order]="button.flexOrder || 0"
    [disabled]="button.disabled || (button.disabledObs | async)"
    [ngClass]="button.class"
    class="btn xux-btn btn-default"
    type="button"
    (click)="actionButtonClick(button.value)"
  >
    <span *ngIf="button.captionObs; else btnCaption">{{ button.captionObs | async | translate}}</span>
    <ng-template #btnCaption>{{ button.caption | translate}}</ng-template>
    <xux-icon *ngIf="button.glyphicon" [icon]="button.glyphicon"></xux-icon>
  </button>

  <ng-template #dropDownBlock>
    <div
      *ngIf="!button.hidden"
      class="xux-dropdown"
      dropdown
      [style.order]="button.flexOrder || 0"
      [ngClass]="'order-' + button.flexOrder"
    >
      <div *ngIf="button.splitDropdown" class="split-dropdown">
        <button
          [disabled]="button.disabled || (button.disabledObs | async)"
          [title]="button.tooltip ? button.tooltip : ''"
          [attr.data-e2e-id]="'modal-btn-' + button.value"
          [ngClass]="button.class"
          class="btn xux-btn"
          type="button"
          (click)="actionButtonClick(button.value)"
        >
          <span *ngIf="button.captionObs; else btnCaption">{{ button.captionObs | async | translate }}</span>
          <ng-template #btnCaption>{{ button.caption | translate }}</ng-template>
          <xux-icon *ngIf="button.glyphicon" [icon]="button.glyphicon"></xux-icon>
        </button>
        <button
          dropdownToggle
          [attr.data-e2e-id]="'modal-btn-toggle-dropdown'"
          [ngClass]="button.class"
          class="btn xux-btn dropdown-toggle"
          type="button"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <xux-icon icon="icon-arrow-down"></xux-icon>
        </button>
      </div>

      <div *ngIf="!button.splitDropdown">
        <button
          dropdownToggle
          [disabled]="button.disabled || (button.disabledObs | async)"
          [title]="button.tooltip ? button.tooltip : ''"
          [attr.data-e2e-id]="'modal-btn-toggle-dropdown'"
          [ngClass]="button.class"
          type="button"
          class="btn xux-btn btn-default dropdown-toggle"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <span *ngIf="button.captionObs; else btnCaption">{{ button.captionObs | async | translate}}</span>
          <ng-template #btnCaption>{{ button.caption }}</ng-template>
          <xux-icon icon="icon-arrow-down"></xux-icon>
        </button>
      </div>
      <div class="dropdown-menu">
        <ul class="dropdown-menu-list-table" *dropdownMenu>
          <li
            *ngFor="let childItem of button.childItems"
            [attr.data-e2e-id]="'xux-btn-' + childItem.value"
            [class.divider]="childItem.value === 'separator'"
            [class.after-last-item]="childItem.class === 'after-last-item'"
          >
            <a
              *ngIf="!childItem.childItems && !childItem.hidden"
              [title]="childItem.tooltip ? childItem.tooltip : ''"
              [class.disabled]="childItem.disabled || (childItem.disabledObs | async)"
              [ngClass]="childItem.class"
              class="xux-action-button btn full-width"
              (click)="actionButtonClick(childItem.value)"
            >
              {{ childItem.caption | translate }}
            </a>

            <ng-template [ngIf]="childItem.childItems && !childItem.hidden">
              <span
                [ngClass]="childItem.class"
                class="xux-action-button btn full-width row-button-cell"
                *ngFor="let cell of childItem.childItems"
              >
                <span [title]="cell.caption">{{ cell.caption | translate}}</span>

                <xux-icon
                  *ngIf="cell.glyphicon"
                  [icon]="cell.glyphicon"
                  class="action-icon"
                  (click)="actionButtonClick(cell.value)"
                ></xux-icon>
              </span>
            </ng-template>
          </li>
          <div class="empty-block" *ngIf="!button.childItems.length"></div>
        </ul>
      </div>
    </div>
  </ng-template>
</div>
